import React from 'react'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {
  convertDateToDisplayFormat,
  convertTimeToLocalDisplayFormat,
} from '../dateFormat/dateFormat'

export const getTooltip = (value, keyPrefix) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id={`tooltip-${keyPrefix}-${value}`}>{value}</Tooltip>}
    >
      <div className="tooltip-format">{value}</div>
    </OverlayTrigger>
  )
}
export const fieldFormating = (value, color = 'dark') => {
  return (
    <div className="wrapper">
      <div className={`subHeading d-flex justify-content-start text-${color}`}>
        {value}
      </div>
    </div>
  )
}
export const headingHighlight = (value, color = 'dark') => {
  return (
    <div className="wrapper">
      <div className={`heading d-flex justify-content-center text-${color}`}>
        {value}
      </div>
    </div>
  )
}
export const headingHighlightUser = (value, color = 'dark') => {
  return (
    <div className="wrapper">
      <div
        className={`heading d-flex justify-content-start text-start text-${color}`}
      >
        {value}
      </div>
    </div>
  )
}
export const formatTimeDate = (value) => {
  return (
    <div className="wrapper">
      <div className="heading d-flex justify-content-center text-dark">
        {convertTimeToLocalDisplayFormat(value)}
      </div>
      <div className="subHeading d-flex justify-content-center">
        {convertDateToDisplayFormat(value)}
      </div>
    </div>
  )
}

export const formatTimeDateAndHighlightDate = (value) => {
  return (
    <div className="wrapper">
      <div className="heading d-flex justify-content-center text-dark">
        {convertDateToDisplayFormat(value)}
      </div>
      <div className="subHeading d-flex justify-content-center">
        {convertTimeToLocalDisplayFormat(value)}
      </div>
    </div>
  )
}

export const getEmptyValue = () => {
  return (
    <div className="wrapper">
      <div className="subHeading d-flex justify-content-center">---</div>
    </div>
  )
}

export const getFiledDataValue = (value) => {
  return (
    <div className="wrapper">
      <div className="subHeading d-flex justify-content-center">{value}</div>
    </div>
  )
}

export const getTablePopover = (data, message) => {
  if (!data?.isActive && message) {
    return <Tooltip>{message}</Tooltip>
  } else {
    return <div></div>
  }
}
